import { createFileRoute, redirect } from '@tanstack/react-router';
import { EventMap } from 'components/maps/EventMap';
import { isRouteAllowed } from 'engine/appConfig';
import { subscribeOrientationListener, unsubscribeOrientationListener } from 'engine/geoLocationAsync';
import { useGpsLocation, useMapMarkers, useStore } from 'engine/store';
import { useWakeLock } from 'engine/wake-lock';
import { useEffect, useState } from 'react';

export const Route = createFileRoute('/map')({
	component: RouteComponent,
	beforeLoad: async () => {
		const { game } = useStore.getState();

		isRouteAllowed('allowGps');

		if (!game) {
			throw redirect({
				to: '/',
			});
		}

		if (!game.showMap) {
			// map not supported!
			throw redirect({
				to: '/',
			});
		}
	},
});

function RouteComponent() {
	const markers = useMapMarkers();
	const gpsLocation = useGpsLocation();
	const [heading, setHeading] = useState<number>(0);

	useWakeLock();

	useEffect(() => {
		const cb = (heading: number | null) => {
			if (heading == null) return;
			setHeading((prev) => (heading == prev ? prev : heading));
		};

		let subscribed = false;

		subscribeOrientationListener(cb);
		subscribed = true;

		return () => {
			if (subscribed) unsubscribeOrientationListener(cb);
		};
	}, []);

	return (
		<div className="size-full">
			<EventMap
				taskMarkers={markers.filter((m) => m.showCoordinates == true)}
				playerLocation={{
					heading: heading || 0,
					lat: gpsLocation.lat,
					lng: gpsLocation.lng,
				}}
			/>
		</div>
	);
}
